
var id = "data";
var markup = "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"data\">\n<mask id=\"data_mask0_1494_39127\" style=\"mask-type:luminance\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0H12V12H24V24H0V0Z\" fill=\"white\" />\n</mask>\n<g mask=\"url(#data_mask0_1494_39127)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 12C0 5.364 5.364 0 12 0C18.636 0 24 5.364 24 12C24 18.636 18.636 24 12 24C5.364 24 0 18.636 0 12ZM2.4 12C2.4 17.292 6.708 21.6 12 21.6C17.292 21.6 21.6 17.292 21.6 12C21.6 6.708 17.292 2.4 12 2.4C6.708 2.4 2.4 6.708 2.4 12Z\" fill=\"#1565C0\" />\n</g>\n<rect x=\"7\" y=\"15\" width=\"2\" height=\"5\" rx=\"1\" fill=\"#1565C0\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 6L13 9L17 5L18 7L13 12L9 9L5 13L4 11L9 6Z\" fill=\"#1565C0\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.0711 2.82843L18.6569 9.89949L13 4.24264L20.0711 2.82843Z\" fill=\"#1565C0\" />\n<rect x=\"11\" y=\"13\" width=\"2\" height=\"7\" rx=\"1\" fill=\"#1565C0\" />\n<rect x=\"15\" y=\"11\" width=\"2\" height=\"9\" rx=\"1\" fill=\"#1565C0\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
